export const PRIORITIES = ["Low", "Medium", "High", "Urgent"];
export const STATUSES = ["New", "Open", "In Progress", "Pending", "Resolved", "Closed"];

export const STATUS_COLOR = {
  New: "blue", Open: "teal", "In Progress": "amber", Pending: "slate", Resolved: "green", Closed: "slate",
};
export const PRIORITY_COLOR = { Low: "slate", Medium: "blue", High: "amber", Urgent: "red" };

export const TRANSITIONS = {
  New: ["Open", "In Progress", "Pending", "Resolved", "Closed"],
  Open: ["In Progress", "Pending", "Resolved", "Closed"],
  "In Progress": ["Open", "Pending", "Resolved", "Closed"],
  Pending: ["Open", "In Progress", "Resolved", "Closed"],
  Resolved: ["Open", "Closed"],
  Closed: ["Open"],
};
